<button id="button" (click)="buttonClicked()"
        [disabled]="disabled || actionIsPending"
        [class]="finalClasses"
        [type]="type"
        [tabIndex]="tabindex">
    <i *ngIf="actionIsPending" class="fa fa-circle-o-notch fa-spin fa-2x fa-fw mr-1"></i>
    <ng-content *ngIf="!actionIsPending"></ng-content>
</button>
